<template>
  <div>
    <b-field grouped>
      <b-input expanded v-model="filters.searchString" placeholder="Carrier Email" />
      <!--
      <b-input expanded v-model="filters.email" placeholder="Email address" />
      <b-input expanded v-model="filters.companyName" placeholder="Company or Facility" />
      <b-select v-model="filters.state" placeholder="State">
        <option></option>
        <option
          v-for="(abbreviation, longName) in usStates"
          :value="abbreviation"
          :key="abbreviation">
          {{longName }}
        </option>
      </b-select>

      <b-input expanded v-model="filters.city" placeholder="City" />
      <b-input expanded v-model="filters.zip" placeholder="Zip Code" />
      -->
    </b-field>
    Carrier Email
    <letter-bar v-model="filters.searchString" />
    <b-table :data="list"
             striped
             hoverable
             :loading="isLoading">

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p v-show="!list.length && !hasFilterValues">Type in a carrier name to search your address book.</p>
            <p v-show="!list.length && !isLoading && hasFilterValues">No matching carriers were found</p>
          </div>
        </section>
      </template>

      <template slot-scope="props">
        <b-table-column v-if="canMakeSelection">
          <a href="" @click.prevent="selectCarrier(props.row)" class="button">Select Carrier</a>
        </b-table-column>

        <b-table-column field="accountLastName" label="Carrier Name">
          {{ props.row.accountFirstName}} {{ props.row.accountLastName}}
        </b-table-column>

        <b-table-column field="accountEmailAddress" label="Email Address">
          {{ props.row.accountEmailAddress}}
        </b-table-column>
        <b-table-column field="accountPhones" label="Phone Number">
          {{ props.row.accountPhones.map(phone => formatPhoneNumber(phone.accountPhoneDigits)).join('\n') }}
        </b-table-column>
        <b-table-column field="carrierEquipmentTruckManufacturer" label="Equipment">
          {{ props.row.carrier ? props.row.carrier.carrierEquipmentTrailerDescription1 : '' }}
          <span v-if="props.row.carrier && props.row.carrier.carrierEquipmentTrailerDescription2">, {{ props.row.carrier.carrierEquipmentTrailerDescription2 }}
          </span>
          <div class="is-size-7" v-if="props.row.carrier">
            {{ props.row.carrier.carrierEquipmentTruckManufacturer }} ({{ props.row.carrier.carrierEquipmentTruckYear }})
          </div>

        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
const DEBOUNCE_TIME = 300
const DEBOUNCE_OPTIONS = {
  leading: true
}
import US_STATES from '@/lookup-data/us-states'

import RolodexApi from '@/api-interface/rolordex'
import { debounce } from 'lodash-es'
import hasEmptyValues from '@/helpers/hasEmptyValues'
import { formatPhoneNumber } from '@/helpers/phoneNumberFormatter'
import LetterBar from '@/components/LetterBar'

export default {
  name: 'RolodexCarrierList',

  props: {
    canMakeSelection: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      usStates: US_STATES,
      isLoading: false,
      filters: {
        searchString: null,
        name: null,
        email: null,
        companyName: null,
        city: null,
        state: null,
        zip: null
      },
      list: []
    }
  },

  created() {
    this.search()
  },

  components: {
    LetterBar
  },

  computed: {
    hasFilterValues() {
      return !hasEmptyValues(this.filters)
    }
  },

  methods: {
    selectCarrier(selection) {
      this.$emit('selected', selection)
    },

    formatPhoneNumber: formatPhoneNumber,

    search: debounce(
      async function() {
        this.isLoading = true
        try {
          if (this.hasFilterValues) {
            this.list = await RolodexApi.carrierSearch(this.filters)
          } else {
            // if no filter values are present, perform a wild-card search
            this.list = await RolodexApi.carrierSearch({ searchString: '%' })
          }
        } catch (error) {
          console.error(`Error searching for [${this.filters}]: `, error)
        } finally {
          this.isLoading = false
        }
      },
      DEBOUNCE_TIME,
      DEBOUNCE_OPTIONS
    )
  },

  watch: {
    filters: {
      deep: true,
      handler: 'search'
    }
  }
}
</script>

<style scoped lang="scss">
.letter-list {
  justify-content: space-between;
}
</style>
